import apiClient from './apiClient';

export const profileService = {
  async getProfile() {
    const response = await apiClient.get('/profile');
    return response.data;
  },

  async updateProfile(data) {
    const response = await apiClient.put('/profile', data);
    return response.data;
  },

  async changePassword(currentPassword, newPassword) {
    const response = await apiClient.put('/profile/password', { currentPassword, newPassword });
    return response;
  },

  async getPreferences() {
    const response = await apiClient.get('/profile/preferences');
    return response.data;
  },

  async updatePreferences(data) {
    const response = await apiClient.put('/profile/preferences', data);
    return response.data;
  }
};

export default profileService;
